import React from 'react';

const CheckCircleIcon = ({fill = "#229DEC"}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M7.00004 0.333496C3.32004 0.333496 0.333374 3.32016 0.333374 7.00016C0.333374 10.6802 3.32004 13.6668 7.00004 13.6668C10.68 13.6668 13.6667 10.6802 13.6667 7.00016C13.6667 3.32016 10.68 0.333496 7.00004 0.333496ZM5.66671 10.3335L2.33337 7.00016L3.27337 6.06016L5.66671 8.44683L10.7267 3.38683L11.6667 4.3335L5.66671 10.3335Z"
      fill={fill}
    />
  </svg>
);

export default CheckCircleIcon;
